import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Liefer-Bestellungen',
    [ORDER_METHODS.PICKUP]: 'Abhol-Bestellungen',
    [ORDER_METHODS.ROOM_SERVICE]: 'Vor Ort-Bestellungen',
  },
  feedback: {
    payment_method_disabled: 'Wir akzeptieren kein {{paymentMethod}} bei {{orderMethod}}',
    cash_disabled: 'Wir akzeptieren kein Bargeld bei {{orderMethod}}',
  },
};
